module.exports = "/_next/static/images/prestaShop-d988fc997b6bfb6797820fb19b137627.png";